import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

import { RtiCard } from './rti-card';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule
  ],
  declarations: [
    RtiCard
  ],
  exports: [
    RtiCard
  ]
})

export class RtiCardModule {
}
